import React from 'react';
import PropTypes from 'prop-types';
import ProductVariationsProp from '../../propTypes/productVariationsProp';

function RemoveCartItemButton(props) {
  const { onRemoveProduct, product } = props;
  return (
    <button
      type="button"
      className="remove-cart-item"
      onClick={() => onRemoveProduct(product.id)}
      aria-label="Remove Product"
    >
      <i className="la la-close" />
    </button>
  );
}

RemoveCartItemButton.propTypes = {
  product: PropTypes.shape(ProductVariationsProp.propType).isRequired,
  onRemoveProduct: PropTypes.func.isRequired,
};

export default RemoveCartItemButton;
